import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../styles';

const LoadingSpinner = () => (
  <SpinnerContainer>
    <Spinner />
  </SpinnerContainer>
);

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 5px solid ${colors.secondary}30;
  border-top: 5px solid ${colors.secondary};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export default LoadingSpinner; 